import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, { CSVExport } from "react-bootstrap-table2-toolkit";
import _ from "lodash";
import jsPDF from "jspdf";
import RegService from "../RegistrationsService";
import overlayFactory from "react-bootstrap-table2-overlay";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  RegistrationStatuses,
  RegistrationTableTypes,
  CompositionModalMode,
  RegisTableType,
} from "../Helpers/LookUpValues";
// import {
//   UncontrolledDropdown,
//   DropdownToggle,
//   DropdownMenu,
//   DropdownItem,
// } from "reactstrap";
// import chistory from "../../Shared/history";
const { ExportCSVButton } = CSVExport;

// Lists at or below this many rows render with no pagination controls at all;
// above it, this is also the page size, so crossing the line always produces a
// real pager rather than a lone rows-per-page dropdown.
const PAGINATION_THRESHOLD = 10;
const TableHeader = (props) => (
  <h6 className="sub_tbl_caption">{props.header}</h6>
);
const RegistrantsActions = (
  cell,
  row,
  handleRegistrationViewClick,
  deleteRegistrant,
  regTableType,
  viewEditReg
) => {
  return (
    <div>
      <div className="actionIcons">
        {regTableType == RegisTableType.AdditionalRegistrants && (
          <i
            className="fas fa-trash c-pointer"
            title="Delete Registrant"
            aria-hidden="true"
            onClick={() => deleteRegistrant(row.id)}
          ></i>
        )}
      </div>
    </div>
  );
};

const NoDataIndication = () => (
  <div class="container h-100">
    <div class="row NoDataFoundTable">
      <h5>No Data Found!</h5>
    </div>
  </div>
);
const Empty = () => <div></div>;
// Explicit widths, because the table otherwise shares space by content and gave REGION so little
// that "NEA-Eastern" wrapped onto two lines, making every row in the group taller. Region and
// facility carry the code and the name now ("NCE-Central", "ZKC-Kansas City ARTCC"), so they need
// more room than they did when they held the name alone, and EMAIL had been taking most of it.
// Percentages rather than pixels because these columns hold variable-length text, but set through
// headerAttrs to match how this file and the rest of the module already size columns (the actions
// column below, InstructorsMembersList, DiscountsListTable, TemplatesListTable, QuestionsListTable).
// They total 93, leaving the selection and action columns to size themselves.
// Tuned against the real grid: region and status now fit on one line, and only the longest
// facility names ("ESW-Engineer/Southwest Region") still take two, which is unavoidable here.

const columns = (handleRegistration, deleteRegistration, regTableType) => [
  {
    text: "FIRST NAME",
    dataField: "firstName",
    sort: true,
    headerAttrs: {
      width: "10%",
    },
  },
  {
    text: "LAST NAME",
    dataField: "lastName",
    sort: true,
    headerAttrs: {
      width: "10%",
    },
  },
  {
    text: "MEMBER NUMBER",
    dataField: "memberNumber",
    sort: true,
    headerAttrs: {
      width: "10%",
    },
  },
  {
    text: "REGION",
    dataField: "region",
    sort: true,
    headerAttrs: {
      width: "12%",
    },
  },
  {
    text: "FACILITY",
    dataField: "facility",
    sort: true,
    headerAttrs: {
      width: "18%",
    },
  },
  {
    text: "EMAIL",
    dataField: "email",
    sort: true,
    headerAttrs: {
      width: "19%",
    },
  },
  {
    text: "REGIS. STATUS",
    dataField: "registrationStatus",
    sort: true,
    headerAttrs: {
      width: "14%",
    },
  },
  {
    text: "Id",
    dataField: "registrationId",
    hidden: true,
    csvExport: false,
  },
  {
    text: "",
    dataField: "actions",
    isDummyField: true,
    hidden: regTableType == RegistrationTableTypes.MemberProfileRegistrations,
    headerClasses: "text-center text-nowrap   text-white px-sm-1 py-2",
    headerAttrs: {
      width: "60px",
    },
    formatter: (cell, row) => {
      return RegistrantsActions(
        cell,
        row,
        handleRegistration,
        deleteRegistration,
        regTableType
      );
    },
    csvExport: false,
  },
];

const MySearch = (props) => {
  let input;
  const handleClick = () => {
    props.onSearch(input.value);
  };
  return (
    <form role="search" className="app-search px-2 my-2">
      <div className="form-group mb-0">
        <input
          ref={(n) => (input = n)}
          type="text"
          id="MemberSearchKeyword"
          className="form-control rounded border mb-1 py-2 w-100"
          placeholder="Member Search.."
          autoComplete="off"
          onChange={handleClick}
        />

        <button className="c-pointer text-secondary bg-transparent border-0">
          <i className="fa fa-search" />
        </button>
      </div>
    </form>
  );
};
const MyExportCSV = (props) => {
  const handleClick = async () => {
    if (props.exportWithAnswers) {
      await props.exportWithAnswers();
      return;
    }

    props.onExport();
  };
  return (
    <div>
      <i
        title="Export to csv"
        className="csvIconSize fas fa-file-csv pl-1"
        onClick={handleClick}
      ></i>
    </div>
  );
};

const escapeCsvField = (value) => {
  const stringValue =
    value === null || value === undefined ? "" : value.toString();

  if (/[",\r\n]/.test(stringValue)) {
    return `"${stringValue.replace(/"/g, '""')}"`;
  }

  return stringValue;
};

const downloadCsv = (filename, headers, rows) => {
  const csvContent = [headers, ...rows]
    .map((row) => row.map(escapeCsvField).join(","))
    .join("\r\n");
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");

  link.href = URL.createObjectURL(blob);
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
};

const getDisambiguatedQuestionHeaders = (questions) => {
  const labelCounts = {};

  return questions.map((question) => {
    const label = `Q: ${question.label || ""}`;
    labelCounts[label] = (labelCounts[label] || 0) + 1;

    return {
      ...question,
      csvHeader:
        labelCounts[label] === 1 ? label : `${label} (${labelCounts[label]})`,
    };
  });
};

const buildAnswerLookup = (answers) => {
  return (answers || []).reduce((lookup, answer) => {
    lookup[`${answer.registrationId}_${answer.questionId}`] =
      answer.answer || "";
    return lookup;
  }, {});
};

///////////********  PDF Export work ***********//////////
const MyExportPDF = (props) => {
  const handleClick = () => {
    _html2canvas(props);
  };
  return (
    <div>
      <i
        title="Export to pdf"
        className="csvIconSize fas fa-file-pdf pl-1"
        onClick={handleClick}
      >
        {" "}
      </i>
    </div>
  );
};
const _html2canvas = async (allprops) => {
  var { data, registrationTitle, regStartDate, caption } = allprops;

  let filename = getExportFileName(
    "pdf",
    registrationTitle,
    regStartDate,
    caption
  );
  if (!_.isEmpty(data)) {
    var tableBody = data.map((val) => {
      var listRow = [];
      listRow.push(val.firstName);
      listRow.push(val.lastName);
      listRow.push(val.memberNumber);
      listRow.push(val.region);
      listRow.push(val.facility);
      listRow.push(val.email);
      listRow.push(val.registrationStatus);
      return listRow;
    });
    const doc = new jsPDF();
    doc.autoTable({
      head: [
        [
          "FIRST NAME",
          "LAST NAME",
          "MEMBER NUMBER",
          "REGION",
          "FACILITY",
          "EMAIL",
          "STATUS",
        ],
      ],
      body: tableBody,
      tableWidth: "auto",
      styles: { cellPadding: 0.7, fontSize: 8 },
      columnStyles: {
        0: { cellWidth: 25 },
        1: { cellWidth: 25 },
        2: { cellWidth: 22 },
      },
    });
    doc.save(filename);
  }
};
// const getExportFileName = (filetype, title) => {
//   const currentDate = new Date();
//   const formattedDate = currentDate
//     .toLocaleDateString("en-US", {
//       year: "2-digit",
//       month: "2-digit",
//       day: "2-digit",
//     })
//     .replace(/\//g, ".");
//   return `Registrants ${title} ${formattedDate}.${filetype}`;
// };
// listLabel is the table's caption ("Registrants", "Waitlist", …). A modal can
// render several of these lists for the same event, so without it every list
// would export under an identical filename.
const getExportFileName = (filetype, title, startDate, listLabel) => {
  const prefix =
    typeof listLabel === "string" && listLabel.trim()
      ? listLabel.trim()
      : "Registrants";

  if (_.isEmpty(startDate) && _.isEmpty(title)) return `${prefix}.${filetype}`;

  if (_.isEmpty(startDate)) return `${prefix} ${title}.${filetype}`;

  const [month, day, year] = startDate.split("/");
  const formattedDate = `${month.padStart(2, "0")}.${day.padStart(
    2,
    "0"
  )}.${year.slice(-2)}`;

  if (_.isEmpty(title)) return `${prefix} ${formattedDate}.${filetype}`;

  return `${prefix} ${title} ${formattedDate}.${filetype}`;
};
///############################(Main function of component)#################################
const RegistrantsMembersList = (props) => {
  const {
    listData,
    handleRegistrationViewClick,
    deleteRegistration,
    isloading,
    registrantTableType,
    openRegistrationForApproval,
    setSelectedRegistrationIds,
    caption,
    registrationTitle,
    registrationWindow,
    childTemplateId,
  } = props;
  const [regStartDate = ""] = registrationWindow ? registrationWindow.split("-") : "";
  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      props.getRegistrantQuestions(row);
    },
  };
  const [selected, setSelected] = useState([]);

  // Rows leave the list when the status filter changes or the data is refetched,
  // but the checkbox state is keyed by registrationId and would keep them
  // selected — so an invisible row could still be submitted. Keep the selection
  // to what the list actually holds. (The in-table search box is not covered:
  // it filters inside the table, below this component.)
  useEffect(() => {
    const visibleIds = (listData || []).map((r) => r.registrationId);
    const stillVisible = selected.filter((id) => visibleIds.includes(id));
    if (stillVisible.length !== selected.length) {
      setSelected(stillVisible);
      setSelectedRegistrationIds(stillVisible);
    }
  }, [listData]);

  const handleOnSelect = (row, isSelect) => {
    if (isSelect) {
      setSelected([...selected, row.registrationId]);
      setSelectedRegistrationIds([...selected, row.registrationId]);
    } else {
      setSelected(selected.filter((x) => x !== row.registrationId));
      setSelectedRegistrationIds(
        selected.filter((x) => x !== row.registrationId)
      );
    }
  };

  const getNonSelectable = (tblType) => {
    ///Additional & MarkAttendance are both tables on the Attendance modal
    if (
      tblType == RegisTableType.MarkAttendance ||
      tblType == RegisTableType.AdditionalRegistrants
    ) {
      // Mark Attendance for only Members which are ***Registered***...
      return listData
        .filter(
          (r) => r.registrationStatusId !== RegistrationStatuses.Registered
        )
        .reduce((acc, r) => {
          acc.push(r.registrationId);
          return acc;
        }, []);
    } else if (tblType == RegisTableType.ReviewRequest) {
      // return listData
      //   .filter(
      //     (r) => r.registrationStatusId == RegistrationStatuses.Registered
      //   )
      //   .reduce((acc, r) => {
      //     acc.push(r.registrationId);
      //     return acc;
      //   }, []);
    }
    {
      return [];
    }
  };
  // The header checkbox only ever reports the rows on the current page, so the
  // selection is merged rather than replaced. Replacing it meant that paging to
  // the second page and ticking the header silently discarded everything picked
  // on the first -- and the admin would only find out from the confirmation
  // list, or not at all.
  const handleOnSelectAll = (isSelect, rows) => {
    const ids = rows.map((r) => r.registrationId);
    const next = isSelect
      ? _.union(selected, ids)
      : selected.filter((id) => !ids.includes(id));
    setSelected(next);
    setSelectedRegistrationIds(next);
  };

  const selectRow = (tblType) => {
    return {
      mode: "checkbox",
      clickToSelect: false,
      selected: selected,
      onSelect: handleOnSelect,
      onSelectAll: handleOnSelectAll,
      nonSelectable: getNonSelectable(tblType),
    };
  };

  const exportRegistrantsWithAnswers = async (data, regStartDate) => {
    const resolvedChildTemplateId =
      childTemplateId ||
      (_.first(data) &&
        (_.first(data).childTemplateId || _.first(data).ChildTemplateId));
    const filename = getExportFileName(
      "csv",
      registrationTitle,
      regStartDate,
      caption
    );
    const fixedHeaders = [
      "FIRST NAME",
      "LAST NAME",
      "MEMBER NUMBER",
      "REGION",
      "FACILITY",
      "EMAIL",
      "REGIS. STATUS",
    ];

    if (!resolvedChildTemplateId) {
      const rows = data.map((registrant) => [
        registrant.firstName,
        registrant.lastName,
        registrant.memberNumber,
        registrant.region,
        registrant.facility,
        registrant.email,
        registrant.registrationStatus,
      ]);
      downloadCsv(filename, fixedHeaders, rows);
      return;
    }

    const { result: exportData = {} } =
      (await RegService.GetRegistrantQuestionAnswerExport(
        resolvedChildTemplateId
      )) || {};
    const questions = getDisambiguatedQuestionHeaders(
      exportData.questions || []
    );
    const answerLookup = buildAnswerLookup(exportData.answers);
    const headers = [
      ...fixedHeaders,
      ...questions.map((question) => question.csvHeader),
    ];
    const rows = data.map((registrant) => [
      registrant.firstName,
      registrant.lastName,
      registrant.memberNumber,
      registrant.region,
      registrant.facility,
      registrant.email,
      registrant.registrationStatus,
      ...questions.map(
        (question) =>
          answerLookup[`${registrant.registrationId}_${question.questionId}`] ||
          ""
      ),
    ]);

    downloadCsv(filename, headers, rows);
  };

  const RemotePagination = (
    data,
    handleRegistration,
    deleteRegistration,
    isloading,
    registrantTableType,
    openRegistrationForApproval,
    rowEvents,
    regStartDate
  ) => (
    <ToolkitProvider
      keyField="registrationId"
      data={data}
      exportCSV={{
        fileName: getExportFileName(
          "csv",
          registrationTitle,
          regStartDate,
          caption
        ),
        exportAll: false,
        onlyExportFiltered: false,
      }}
      columns={columns(
        handleRegistration,
        deleteRegistration,
        registrantTableType,
        openRegistrationForApproval,
        rowEvents
      )}
      search
    >
      {(props) => (
        <div>
          <div className="d-flex justify-content-end">
            <MyExportCSV
              {...props.csvProps}
              exportWithAnswers={() =>
                exportRegistrantsWithAnswers(data, regStartDate)
              }
            />
            <MyExportPDF
              data={data}
              registrationTitle={registrationTitle}
              regStartDate={regStartDate}
              caption={caption}
            />
          </div>

          <MySearch {...props.searchProps} />

          <BootstrapTable
            keyField="registrationId"
            selectRow={selectRow(registrantTableType)}
            // Classes can run to seventy or more registrants. Short lists get
            // no pagination at all -- passing undefined drops the page numbers
            // AND the rows-per-page dropdown, which `hidePageListOnlyOnePage`
            // alone would have left stranded under a six row table.
            pagination={
              (data || []).length > PAGINATION_THRESHOLD
                ? paginationFactory({
                    sizePerPage: PAGINATION_THRESHOLD,
                    hideSizePerPage: false,
                    sizePerPageList: [
                      { text: "10", value: 10 },
                      { text: "25", value: 25 },
                      { text: "50", value: 50 },
                      { text: "100", value: 100 },
                    ],
                  })
                : undefined
            }
            overlay={overlayFactory({
              spinner: true,
              styles: {
                overlay: (base) => ({
                  ...base,
                  background: "rgba(40, 45, 42, 0.19)",
                }),
              },
            })}
            noDataIndication={() => {
              return isloading === false ? <NoDataIndication /> : <Empty />;
            }}
            loading={isloading}
            rowEvents={
              registrantTableType == RegisTableType.ReviewRequest
                ? rowEvents
                : {}
            }
            rowClasses={`${registrantTableType == RegisTableType.ReviewRequest
              ? "c-pointer"
              : ""
              }`}
            caption={<TableHeader header={caption} />}
            {...props.baseProps}
          />
          <br />
        </div>
      )}
    </ToolkitProvider>
  );

  return (
    <>
      {RemotePagination(
        listData,
        handleRegistrationViewClick,
        deleteRegistration,
        isloading,
        registrantTableType,
        openRegistrationForApproval,
        rowEvents,
        regStartDate.trim()
      )}
    </>
  );
};

RegistrantsMembersList.propTypes = {
  listData: PropTypes.array.isRequired,
};

RegistrantsMembersList.defaultProps = {
  listData: [],
};

export default RegistrantsMembersList;
